import { useState, useEffect } from "react";
import apiClient from "../components/apiClient"; // Axios instance
import { Navigate, useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  // Get JWT token from ?cd=... on first render
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const cd = urlParams.get("cd");
    if (cd) setToken(cd);
    else setError("Invalid or missing token.");
  }, []);

  const handleReset = async () => {
    setMessage("");
    setError("");

    if (!newPassword || !confirmPassword) {
      setError("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const response = await apiClient.post(
        "/user/resetpassword",
        { password: newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`, // JWT goes here
          },
        }
      );

      const result = response.data;

      if (response.status === 200) {
        setMessage(result.message || "Password successfully reset!");
        setNewPassword("");
        setConfirmPassword("");
        setTimeout(() => navigate("/login"), 5000);
      } else {
        setError(result.message || "Something went wrong.");
      }
    } catch (err) {
      console.error("Reset password error:", err);
      setError(
        err.response?.data?.message || "Server error. Please try again later."
      );
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white w-full max-w-lg rounded-lg shadow-xl p-8 space-y-6">
        <h1 className="text-3xl font-bold text-center text-gray-900">
          Reset Password
        </h1>

        {message && (
          <p className="text-green-600 text-center text-sm">{message}</p>
        )}
        {error && <p className="text-red-500 text-center text-sm">{error}</p>}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              New Password
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-md bg-gray-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="••••••••"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm New Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-md bg-gray-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
              placeholder="••••••••"
            />
          </div>
        </div>

        <button
          onClick={handleReset}
          className="w-full py-3 bg-black text-white text-lg font-semibold rounded-md hover:bg-gray-800 transition-all duration-300"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
